/* tslint:disable */
/* eslint-disable */
export enum UserPrebidAlertState {
  Normal = 'normal',
  Firing = 'firing',
  Suppressed = 'suppressed'
}
